import React, { Component } from "react";
import { withRouter } from "react-router-dom";

import Api from "../../../lib/componentApi";
import getAppErrors from "../../../lib/appErrors";
import validateForm from "../../../lib/validateForm";
import mixpanel from "../../../lib/mixPanel";

import AppErrors from "../../../components/Common/AppErrors";
import WithFacebookForm from "../../../components/Auth/WithFacebookForm";

class WithFacebook extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mobileNumber: "",
      email: "",
      password: "",
      loading: false,
      formErrors: {
        email: "",
        password: "",
        mobileNumber: ""
      },
      errorMessage: null,
      active: false,
      showErrors: false
    };
  }
  onChange = event => {
    event.preventDefault();
    const input = event.target.id;
    this.setState(
      {
        [input]: event.target.value.trim(),
        showErrors: false
      },
      () => {
        const currentState = { [input]: this.state[input] };
        const inputError = validateForm(currentState, "facebook");
        const { formErrors } = this.state;
        formErrors[input] = inputError;
        this.setState({ formErrors }, () => {
          const { email, password, mobileNumber } = this.state;
          const { emailRequired } = this.props;
          let errors = Object.values(this.state.formErrors).filter(Boolean);
          if (emailRequired) {
            if (email && password && mobileNumber && !errors.length) {
              this.setState({ active: true });
            } else {
              this.setState({ active: false });
            }
          } else {
            if (password && mobileNumber && !errors.length) {
              this.setState({ active: true });
            } else {
              this.setState({ active: false });
            }
          }
        });
      }
    );
  };
  isValid = () => {
    const { email, password, mobileNumber } = this.state;
    const { emailRequired } = this.props;
    const errors = Object.values(this.state.formErrors).filter(Boolean);
    const isEmailCheck = emailRequired ? email : true;
    if (isEmailCheck && password && mobileNumber && !errors.length) {
      return true;
    } else {
      this.setState(
        {
          showErrors: true
        },
        () => {
          return false;
        }
      );
    }
  };
  _confirm = data => {
    const { onSubmit } = this.props;
    const token = data.token || "";
    if (token) {
      mixpanel.people.set({ "Connected Facebook": true, Platform: "Web" });
      if (onSubmit) {
        //update user gelecek
        onSubmit(data, event);
      } else {
        window.location.href = "/";
      }
    } else {
      mixpanel.people.set({ "Connected Facebook": false, Platform: "Web" });
      window.location.href = "/";
    }
  };
  handleSubmit = event => {
    event.preventDefault();
    const isValid = this.isValid();
    if (isValid) {
      const { fbAccessToken, refKey } = this.props;
      const { email, password, mobileNumber } = this.state;
      Api.post(
        "/api/registerWithFacebook",
        {
          fbAccessToken,
          email,
          password,
          mobileNumber,
          refKey
        },
        (response, errors) => {
          if (errors) {
            if (errors === 503) {
              this.setState(() => {
                throw errors;
              });
            } else {
              console.log(errors);
            }
          } else if (response.code) {
            const errorMessage = getAppErrors(response.code);
            this.setState({
              errorMessage:
                (errorMessage && errorMessage.message) || response.message,
              active: false
            });
          } else {
            this._confirm(response);
          }
        }
      );
    }
  };
  submitPhoneNumber = (mobileNumber, error) => {
    const { email, password, formErrors } = this.state;
    const errors = Object.values(this.state.formErrors).filter(Boolean);
    if (error) {
      this.setState({
        formErrors: {
          ...formErrors,
          mobileNumber: error
        },
        showErrors: false,
        active: false
      });
    } else {
      this.setState(
        {
          mobileNumber,
          showErrors: false,
          formErrors: {
            ...formErrors,
            mobileNumber: ""
          }
        },
        () => {
          const { emailRequired } = this.props;
          const isEmailCheck = emailRequired ? email : true;
          if (isEmailCheck && password && mobileNumber && !errors.length) {
            this.setState({ active: true });
          } else {
            this.setState({ active: false });
          }
        }
      );
    }
  };
  onClickClose = () => {
    this.setState({
      errorMessage: ""
    });
  };
  render() {
    const { errorMessage, active, formErrors, showErrors } = this.state;
    const { onCloseSection, emailRequired } = this.props;
    return (
      (errorMessage && (
        <AppErrors message={errorMessage} onClickClose={this.onClickClose} />
      )) || (
        <WithFacebookForm
          onChange={this.onChange}
          handleSubmit={this.handleSubmit}
          onCloseSection={onCloseSection}
          emailRequired={emailRequired}
          active={active}
          formErrors={formErrors}
          submitPhoneNumber={this.submitPhoneNumber}
          showErrors={showErrors}
        />
      )
    );
  }
}

export default withRouter(WithFacebook);
